/**
 * @generated SignedSource<<90749f800c988f7a947eb15278283c05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RecordImpressionMutationInput = {
  clientMutationId?: string | null;
  name: string;
  treatmentType: string;
};
export type RecordImpressionMutation$variables = {
  input: RecordImpressionMutationInput;
};
export type RecordImpressionMutation$data = {
  readonly recordImpression: {
    readonly clientMutationId: string | null;
  } | null;
};
export type RecordImpressionMutation = {
  variables: RecordImpressionMutation$variables;
  response: RecordImpressionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RecordImpressionMutationPayload",
    "kind": "LinkedField",
    "name": "recordImpression",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecordImpressionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecordImpressionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "16ba0f6faa19eebf1f84ab3597ff45bd",
    "id": null,
    "metadata": {},
    "name": "RecordImpressionMutation",
    "operationKind": "mutation",
    "text": "mutation RecordImpressionMutation(\n  $input: RecordImpressionMutationInput!\n) {\n  recordImpression(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "4d872c0fc5101558a6df8f82e755514e";

export default node;
